import React from 'react';
import AddButton from 'shared/ui/AddButton';
import Wrapper from './styled';
import { useDispatch, useSelector } from 'react-redux';
import { setIsCreateSchedule } from 'store/Schedule/actions';
import { MODAL_SCHEDULE_CREATE_EDIT } from 'store/modals/modals';
import { openModal } from 'store/modals/actions';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_SCHEDULER, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';
import { useIntl } from 'react-intl';

const CreateButton = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const allowedByRole = useSelector((state) => selectAllowedByRole(state, FEATURE_SCHEDULER, PERMISSION_TYPES.CREATE));

  const handleClick = () => {
    if (allowedByRole) {
      dispatch(setIsCreateSchedule(true));
      dispatch(openModal(MODAL_SCHEDULE_CREATE_EDIT));
    }
  };

  return (
    <Wrapper>
      <AddButton title="Create" onClick={ handleClick } disabled={ !allowedByRole }>
        {intl.formatMessage({ id: 'common.button.add.schedule' }) }
      </AddButton>
    </Wrapper>
  );
};

export default CreateButton;
